import React, { memo } from 'react';
import AbsoluteEmpty from 'components/AbsoluteEmpty';
import { Button } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const AutomationsListEmptyView = memo(({ emptyViewProps }) => {
    return (
        <div className="fm-automation-settings__empty-view">
            <AbsoluteEmpty
                title={getLiteral('label_automations_empty_page')}
                subtitle={getLiteral('label_automations_empty_page_desc')}
                actions={[
                    emptyViewProps.onCreate ? (
                        <Button type="secondary" onClick={emptyViewProps.onCreate}>
                            {getLiteral('action_automation_create')}
                        </Button>
                    ) : null,
                    emptyViewProps.onTemplates ? (
                        <Button type="secondary" onClick={emptyViewProps.onTemplates}>
                            {getLiteral('action_automation_create_from_template')}
                        </Button>
                    ) : null,
                ]}
            />
        </div>
    );
});

export default AutomationsListEmptyView;
